<template>
  <span :class="style.heading">Bitrix24</span>
  <div :class="style.inputs">
    <InputStyle
      size="M"
      placeholder="Название интеграции"
      description="Название"
      v-model="localIntegration.name"
    />
    <InputStyle
      size="M"
      placeholder="https://example.bitrix24.ru/rest/1/token/"
      description="Webhook"
      v-model="localIntegration.webhook"
    />
    <InputStyle
      size="M"
      placeholder="Заявка с Readds"
      description="Название заявки"
      v-model="localIntegration.nameApplication"
    />
  </div>
  <div :class="style.buttons">
    <PrimaryButton
      :text="edit ? 'Сохранить' : 'Добавить интеграцию'"
      @click="saveIntegration"
    />
    <SecondaryButton
      text="Удалить"
      v-if="edit"
      :icon="trashIcon"
      @click="$emit('delete')"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "./settingIntegrations.module.scss";
import PrimaryButton from "@/elements/UI/button/ButtonStyle/Default/primary/PrimaryButton.vue";
import SecondaryButton from "@/elements/UI/button/ButtonStyle/Default/secondary/SecondaryButton.vue";
import trashIcon from "$images/icons/button/Name=Trash, Size=16, Tone=Default.svg";
import {bitrixCrmIntegration} from "@/page/setting/integration/IntegrationTypes";
import InputStyle from "@/elements/UI/input/Style/InputStyle.vue";

export default defineComponent({
  name: "SettingIntegrationBitrixCRM",
  components: {InputStyle, SecondaryButton, PrimaryButton},
  emits: ["delete", "closeModal"],
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    integration: {
      type: Object as PropType<bitrixCrmIntegration>,
      default: () => ({})
    },
    integrationIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      style,
      trashIcon,
      localIntegration: {
        id: this.integration.id ?? "",
        name: this.integration.name ?? "",
        webhook: this.integration.webhook ?? "",
        nameApplication: this.integration.nameApplication ?? ""
      }
    };
  },
  methods: {
    saveIntegration() {
      const integration = this.getIntegration.bitrixCrm;

      if (!integration || !this.localIntegration.webhook.trim()) return;

      const value = {
        ...this.localIntegration,
        name: this.localIntegration.name.trim(),
        webhook: this.localIntegration.webhook.trim(),
        nameApplication: this.localIntegration.nameApplication.trim()
      };

      if (
        this.edit &&
        this.integrationIndex >= 0 &&
        this.integrationIndex < integration.integration.length
      ) {
        integration.integration[this.integrationIndex] = value;
      } else {
        integration.integration.push(value);
      }

      this.$emit("closeModal");
    }
  },
  computed: {
    getIntegration() {
      return this.$integrationStore.getIntegration;
    }
  },
  watch: {
    integration: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (!newVal) return;

        this.localIntegration = {
          id: newVal.id || "",
          name: newVal.name || "",
          webhook: newVal.webhook || "",
          nameApplication: newVal.nameApplication || ""
        };
      }
    }
  }
});
</script>
